<template>
  <div class="content">
    <div class="con">
      <div class="con-box">
        <div class="con-head">
          <!-- <div
            class="con-title"
            :class="appoinselected == 0 ? 'active' : ''"
            @click="tabTap(0)"
          >
            开处方
          </div> -->
          <div
            class="con-title"
            :class="appoinselected == 0 ? 'active' : ''"
            @click="tabTap(0)"
            style="width:100%"
          >
            申请开方信息
          </div>
          <!-- <div
            class="con-title"
            :class="appoinselected == 1 ? 'active' : ''"
            @click="tabTap(1)"
          >
            提交处方
          </div> -->
        </div>
        <div class="open" v-if="appoinselected == 0">
          <div class="open-con">
            <div class="open-word">请填写用户信息</div>
            <div class="item">
              <div class="item-left">姓名</div>
              <div class="item-right">
                <input
                  type="text"
                  name="name"
                  value=""
                  placeholder="请输入您的姓名"
                  required
                  ref="name"
                  v-on:keyup="inputRef"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-left">年龄</div>
              <div class="item-right">
                <input
                  type="number"
                  name="age"
                  value=""
                  placeholder="请输入您的年龄"
                  required
                  ref="age"
                  v-on:keyup="inputAge"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-left" style="width:auto;">出生日期</div>
              <div
                class="item-right"
                style="width: 78%;margin-left:1%"
                id="birth"
              >
                <input
                  type="text"
                  name="birthday"
                  value=""
                  placeholder="(如:1990-01-01)"
                  required
                  ref="birthday"
                  v-on:keyup="inputBirthday"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-left">性别</div>
              <div class="item-right">
                <label class="item-right-text" @click="sextype(1)">
                  <span
                    :class="
                      'radio ' + (sexcheck == 1 ? 'checked iconfont' : '')
                    "
                  ></span
                  >男
                </label>
                <label class="item-right-text" @click="sextype(2)">
                  <span
                    :class="
                      'radio ' + (sexcheck == 2 ? 'checked iconfont' : '')
                    "
                  ></span
                  >女
                </label>
              </div>
            </div>
            <div class="item">
              <div class="item-left">手机号</div>
              <div class="item-right">
                <input
                  type="text"
                  name="phone"
                  value=""
                  placeholder="请输入您的手机号码"
                  ref="phone"
                  v-on:keyup="inputtell"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-left">身份证号</div>
              <div class="item-right">
                <input
                  type="text"
                  name="card"
                  value=""
                  placeholder="请输入您的身份证号"
                  ref="card"
                  v-on:keyup="inputcard"
                />
              </div>
            </div>
            <div class="des">
              <div class="des-left">病情描述</div>
              <div class="des-right">
                <textarea
                  class="textarea"
                  value=""
                  placeholder="请描述您目前的症状"
                  ref="describe"
                  v-on:keyup="inputdescribe"
                />
              </div>
            </div>
            <div class="item">
              <div class="item-left">是否有现病史</div>
              <div class="item-right">
                <label class="item-right-text" @click="nlistype(0)">
                  <span
                    :class="
                      'radio ' + (nlischeck == 0 ? 'checked iconfont' : '')
                    "
                  ></span
                  >是
                </label>
                <label class="item-right-text" @click="nlistype(1)">
                  <span
                    :class="
                      'radio ' + (nlischeck == 1 ? 'checked iconfont' : '')
                    "
                  ></span
                  >否
                </label>
              </div>
            </div>
            <div class="item">
              <div class="item-left">是否有既往病史</div>
              <div class="item-right">
                <label class="item-right-text" @click="listype(0)">
                  <span
                    :class="
                      'radio ' + (lischeck == 0 ? 'checked iconfont' : '')
                    "
                  ></span
                  >是
                </label>
                <label class="item-right-text" @click="listype(1)">
                  <span
                    :class="
                      'radio ' + (lischeck == 1 ? 'checked iconfont' : '')
                    "
                  ></span
                  >否
                </label>
              </div>
            </div>
            <div class="item">
              <div class="item-left">是否有过敏史</div>
              <div class="item-right">
                <label class="item-right-text" @click="allergytype(0)">
                  <span
                    :class="'radio ' + (allergy == 0 ? 'checked iconfont' : '')"
                  ></span
                  >是
                </label>
                <label class="item-right-text" @click="allergytype(1)">
                  <span
                    :class="'radio ' + (allergy == 1 ? 'checked iconfont' : '')"
                  ></span
                  >否
                </label>
              </div>
            </div>
            <div class="item">
              <div class="item-left">肝功能是否异常</div>
              <div class="item-right">
                <label class="item-right-text" @click="livertype(0)">
                  <span
                    :class="'radio ' + (liver == 0 ? 'checked iconfont' : '')"
                  ></span
                  >是
                </label>
                <label class="item-right-text" @click="livertype(1)">
                  <span
                    :class="'radio ' + (liver == 1 ? 'checked iconfont' : '')"
                  ></span
                  >否
                </label>
              </div>
            </div>
            <div class="item">
              <div class="item-left">肾功能是否异常</div>
              <div class="item-right">
                <label class="item-right-text" @click="kidneytype(0)">
                  <span
                    :class="'radio ' + (kidney == 0 ? 'checked iconfont' : '')"
                  ></span
                  >是
                </label>
                <label class="item-right-text" @click="kidneytype(1)">
                  <span
                    :class="'radio ' + (kidney == 1 ? 'checked iconfont' : '')"
                  ></span
                  >否
                </label>
              </div>
            </div>
            <div class="item">
              <div class="item-left">是否备孕/怀孕</div>
              <div class="item-right">
                <label class="item-right-text" @click="pregnancytype(0)">
                  <span
                    :class="
                      'radio ' + (pregnancy == 0 ? 'checked iconfont' : '')
                    "
                  ></span
                  >是
                </label>
                <label class="item-right-text" @click="pregnancytype(1)">
                  <span
                    :class="
                      'radio ' + (pregnancy == 1 ? 'checked iconfont' : '')
                    "
                  ></span
                  >否
                </label>
              </div>
            </div>
            <div class="item">
              <div class="item-left">是否在哺乳期</div>
              <div class="item-right">
                <label class="item-right-text" @click="burutype(0)">
                  <span
                    :class="
                      'radio ' + (burucheck == 0 ? 'checked iconfont' : '')
                    "
                  ></span
                  >是
                </label>
                <label class="item-right-text" @click="burutype(1)">
                  <span
                    :class="
                      'radio ' + (burucheck == 1 ? 'checked iconfont' : '')
                    "
                  ></span
                  >否
                </label>
              </div>
            </div>
            <!-- <div class="des">
			  <div class="des-left">病情描述</div>
			  <div class="des-right">
			    <textarea
			      class="textarea"
			      value=""
			      placeholder="请描述您目前的症状"
			      ref="describe"
			      v-on:keyup="inputdescribe"
			    />
			  </div>
			</div> -->
            <!-- <div class="item yao">
							<div class="item-left">药品费用</div>
							<div class="item-right green">￥80</div>
						</div>
						<div class="item yao">
							<div class="item-left">挂号费用</div>
							<div class="item-right green">￥80</div>
						</div> -->
          </div>
        </div>
        <!-- <div class="open" v-else>
          <div class="open-con">
            <div class="tiword">上传已有处方</div>
            <div class="imgbox"></div>
            <div class="titext">提交后等待审方人审核</div>
            <div class="item yao">
              <div class="item-left">药品费用</div>
              <div class="item-right green">￥100</div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="open-confoot foot" style="height:90px">
      <div style="text-align:center">
        <label class="item-right-text" @click="zdtype">
          <span
            :class="'radio ' + (zdcheck == 1 ? 'checked iconfont' : '')"
          ></span>
        </label>
        <span @click="zdbook">互联网诊疗风险告知及知情同意书</span>
      </div>
      <div class="foot-btn" @click="nethosp">申请处方</div>
    </div>
  </div>
</template>
<style>
#birth input::-webkit-input-placeholder {
  text-align: left;
}
.content {
  width: 100%;
  background: linear-gradient(to bottom, #07c04d 0, #fff 150px);
  background: -webkit-linear-gradient(top, #07c04d 0, #fff 150px);
}
.head {
  width: 100%;
  height: 44px;
  box-sizing: border-box;
  padding: 0 15px;
  position: relative;
}
.head-word {
  color: #fff;
  font-size: 15px;
  line-height: 44px;
  text-align: center;
  font-weight: 700;
}
.head img {
  float: left;
  width: 20px;
  height: 20px;
  vertical-align: text-top;
  position: absolute;
  top: 50%;
  top: 0;
  bottom: 0;
  left: 15px;
  margin: auto;
}
.con {
  width: 100%;
  height: auto;
  padding: 4%;
  box-sizing: border-box;
  margin-bottom: 80px;
}
.con-box {
  width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
.con-head {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
}
.con-title {
  width: 50%;
  text-align: center;
  line-height: 50px;
  border-radius: 12px 12px 0 0;
  color: #fff;
  background-color: #07c04d;
  font-size: 14px;
}
.con-title.active {
  color: #2b2b2b;
  background-color: #ffffff;
}
.open {
  width: 100%;
}
.open-con {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 0 0 10px 10px;
}
.open-word {
  color: #07c04d;
  font-size: 15px;
  font-weight: bold;
  border-bottom: #aeaeae 1px solid;
  height: 45px;
  line-height: 45px;
}
.open-con .item {
  border-bottom: #aeaeae 1px solid;
  height: 45px;
  line-height: 45px;
  /* position: relative; */
  display: flex;
}
.open-con .item.yao {
  border-bottom: 0;
}
.item-right.green {
  color: #07c04d;
  font-weight: bold;
}
.item-left {
  /* float: left; */
  color: #302f2f;
  font-size: 14px;
  width: 40%;
}
.item-right {
  /* float: right; */
  text-align: right;
  color: #989898;
  font-size: 15px;
  width: 60%;
  padding-right: 2%;
  /* position: absolute; */
  /* right: 0; */
  /* top: 50%; */
  /* transform: translateY(-50%); */
}
.item-right input {
  width: 100%;
  text-align: right;
}
.item-right input[type="radio"] {
  /* border-radius: 10px; */
  padding: 14px;
  -webkit-appearance: radio;
}
.des {
  border-bottom: #aeaeae 1px solid;
  height: auto;
}
.des-left {
  color: #302f2f;
  font-size: 14px;
  line-height: 45px;
}
.des-right {
  color: #989898;
  font-size: 15px;
  height: 50px;
}
.des-right textarea {
  width: 100%;
  height: 100%;
}
.open-confoot.foot {
  width: 100%;
  height: 50px;
  position: fixed;
  left: 0;
  bottom: 0;
  line-height: 40px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.open-confoot .foot-word {
  /* float: left; */
  color: #7f7f7f;
  font-size: 24rpx;
  margin: 0 60px;
}
.open-confoot .foot-money {
  /* float: left; */
  color: #07c04d;
  font-size: 15px;
  font-weight: bold;
}
.open-confoot .foot-btn {
  width: 90%;
  margin: 0 auto;
  border-radius: 50px;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  background-color: #07c04d;
}
.tiword {
  color: #07c04d;
  font-size: 13px;
}
.imgbox {
  width: 100%;
  height: 200px;
}
.titext {
  width: 100%;
  height: 45px;
  color: #989898;
  font-size: 12px;
  border-bottom: #989898 1px solid;
  text-align: center;
  line-height: 45px;
}
.item-right-text .radio {
  width: 15px;
  height: 15px;
  display: inline-block;
  border: 1px solid #07c04d;
  vertical-align: sub;
  margin-right: 5px;
  margin-left: 10px;
}
.item-right-text .radio.checked {
  position: relative;
  background-color: #07c04d;
  border-color: #07c04d;
}
.item-right-text .radio.checked:before {
  /* font: normal normal normal 14px/1; */
  content: "\E8CA";
  color: #fff;
  font-size: 15px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -48%) scale(0.73);
  -webkit-transform: translate(-50%, -48%) scale(0.73);
}
</style>
<script>
import { formnethosp } from "@api/store";
import axios from "axios";
export default {
  name: "GoodsRecipel",
  components: {},
  data: function() {
    const { orderid = 0 } = this.$route.query;
    return {
      name: "", //姓名
      age: 0,
      birthday: "",
      sexcheck: 1, //性别
      tell: "", //电话号
      card: 0,
      describe: "", //病情描述
      nlischeck: 1, //是否有现病史
      lischeck: 1, //是否有既往病史
      allergy: 1, //是否有过敏史
      liver: 1, //肝功能
      kidney: 1, //肾功能
      pregnancy: 1, //备孕、怀孕
      burucheck: 1, //哺乳期
      appoinselected: 0,
      zdcheck: 1,
      orderid: orderid
    };
  },
  // data:{
  // 	name:"",//姓名
  // 	sexcheck:0,//性别
  // 	tell:"",//电话号
  // 	describe:"",//病情描述
  // 	nlischeck:1,//是否有现病史
  // 	lischeck:1,//是否有既往病史
  // 	allergy:1,//是否有过敏史
  // 	liver:1,//肝功能
  // 	kidney:1,//肾功能
  // 	pregnancy:1,//备孕、怀孕
  // 	burucheck:1,//哺乳期
  // 	appoinselected: 0,
  // },
  mounted: function() {},
  methods: {
    zdbook: function() {
      this.$router.push({
        path: "/zdbook"
      });
    },
    zdtype: function() {
      if (this.zdcheck == 1) {
        this.zdcheck = 0;
      } else {
        this.zdcheck = 1;
      }
    },
    inputRef: function() {
      this.name = this.$refs.name.value;
    },
    inputAge: function() {
      this.age = this.$refs.age.value;
    },
    inputBirthday: function() {
      this.birthday = this.$refs.birthday.value;
    },
    inputtell: function() {
      this.tell = this.$refs.phone.value;
    },
    inputcard: function() {
      this.card = this.$refs.card.value;
    },
    sextype: function(type) {
      this.sexcheck = type;
    },
    inputdescribe: function() {
      this.describe = this.$refs.describe.value;
    },
    nlistype: function(type) {
      this.nlischeck = type;
    },
    listype: function(type) {
      this.lischeck = type;
    },
    allergytype: function(type) {
      this.allergy = type;
    },
    livertype: function(type) {
      this.liver = type;
    },
    kidneytype: function(type) {
      this.kidney = type;
    },
    pregnancytype: function(type) {
      this.pregnancy = type;
    },
    burutype: function(type) {
      this.burucheck = type;
    },
    tabTap(index) {
      this.appoinselected = index;
    },
    nethosp() {
      var form = {};
      form.rpId = this.orderid; //订单号
      form.patientName = this.name; //姓名
      form.patientAge = this.age; //年龄
      form.patientBirthday = this.birthday; //生日
      form.patientGender = this.sexcheck; //性别
      form.patientTel = this.tell; //电话
      form.patientIdentityNo = this.card; //身份证号
      form.diseaseDesc = this.describe; //病情描述
      // form.nlis = this.nlischeck; //是否有现病史
      // form.lis = this.lischeck; //是否有既往病史
      let historyAllergic = this.allergy == 0 ? "有" : "无";
      form.historyAllergic = historyAllergic; //是否有过敏史
      // form.liver = this.liver; //肝功能
      // form.kidney = this.kidney; //肾功能
      // form.pregnancy = this.pregnancy; //备孕、怀孕
      // form.buru = this.burucheck; //哺乳期
      form.diagnosis = "";
      form.diseaseImgUrl = "";
      form.pharmacistName = "";
      form.configPharmacistName = "";
      form.extend = "";
      form.sign = "";
      if (!form.patientName) {
        return this.$dialog.toast({
          mes: "请输入姓名"
        });
      }
      if (!form.patientAge) {
        return this.$dialog.toast({
          mes: "请输入年龄"
        });
      }
      if (!form.patientBirthday) {
        return this.$dialog.toast({
          mes: "请输入出生日期"
        });
      }
      if (!form.patientTel) {
        return this.$dialog.toast({
          mes: "请输入联系电话"
        });
      }
      if (!form.patientIdentityNo) {
        return this.$dialog.toast({
          mes: "请输入身份证号"
        });
      }
      if (!form.diseaseDesc) {
        return this.$dialog.toast({
          mes: "请输入病情描述"
        });
      }
      if (!this.zdcheck) {
        return false;
      }
      formnethosp(form).then(res => {
        if (res.status == "200") {
          this.$dialog.toast({
            mes: "申请成功,等待医师开方"
          });
          this.$router.replace({
            path: "/order/detail/" + this.orderid
          });
        } else {
          return this.$dialog.toast({
            mes: "提交申请失败"
          });
        }
      });
    }
  }
};
</script>
